import { render, staticRenderFns } from "./StaffFiles.vue?vue&type=template&id=767bff60&scoped=true&"
import script from "./StaffFiles.vue?vue&type=script&lang=js&"
export * from "./StaffFiles.vue?vue&type=script&lang=js&"
import style0 from "./StaffFiles.vue?vue&type=style&index=0&lang=less&"
import style1 from "./StaffFiles.vue?vue&type=style&index=1&id=767bff60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!/////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767bff60",
  null
  
)

export default component.exports